import React from 'react'
import { getYouTubeEmbedUrl } from '@/lib/youtube'

interface YouTubeEmbedProps {
  videoId: string
  title?: string
  className?: string
}

export function YouTubeEmbed({ videoId, title = 'YouTube video', className = '' }: YouTubeEmbedProps) {
  return (
    <div
      className={`relative aspect-video w-full overflow-hidden rounded-xl bg-gray-900 ${className}`}
    >
      <iframe
        src={getYouTubeEmbedUrl(videoId)}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="absolute inset-0 h-full w-full border-0"
      />
    </div>
  )
}
